module.exports = __webpack_public_path__ + "img/BannerNewMobileMultihogar.c4e66e7c.jpg";